import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useExpenseTypes, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const ExpenseTypesPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="expenseTypes"
      hook={useExpenseTypes}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addExpenseType"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="expenseType"
    />
  );
};

export default ExpenseTypesPage; 